import { getRemainingTime } from "common/utils/time";

export const formatRemaining = (remaining: number): string => {
  if (remaining <= 9) {
    return `0${remaining}`;
  }
  return `${remaining}`;
};

export const getDaysRemaining = (deadline: string) => {
  return getRemainingTime(deadline, "days");
};

export const getHoursRemaining = (deadline: string) => {
  return getRemainingTime(deadline, "hours");
};

export const getMinutesRemaining = (deadline: string) => {
  return getRemainingTime(deadline, "minutes");
};
